<template>
  <div>
    <div class="flex flex-col items-start gap-[26px]">
      <!-- Breadcrumb -->
      <Breadcrumb />
      <!-- Breadcrumb -->
      <div class="w-full flex flex-col items-start gap-[26px]" ref="pdfRef">
        <div class="w-full flex flex-col items-start gap-[20px]">
          <div class="w-full flex flex-col items-start gap-[6px]">
            <div class="PC_H2-SB text-[#1F1D1F]">รายงานการปฏิบัติการฉุกเฉิน</div>
          </div>
          <div class="w-full flex items-center gap-[8px]">
            <div v-if="isEdit" class="w-full flex flex-row items-start gap-[8px]">
              <div class="min-w-[78px] mt-[8px] title">วันที่ประเมิน</div>
              <div class="w-full sm:w-fit sm:min-w-[257px]">
                <DatePicker2 :modelValue="form.datetime" @update:modelValue="(date) => selectCreateDate(date)" />
                <div v-if="errors.datetime" class="textError mt-[8px]">
                  {{ errors.datetime }}
                </div>
              </div>
            </div>
            <div v-else class="w-full flex items-center justify-between gap-[10px] flex-wrap sm:flex-nowrap">
              <div class="flex items-center gap-[20px] flex-wrap sm:flex-nowrap">
                <div class="flex flex-col">
                  <div class="PC_Body2-R text-[#7C7379]">ครั้งที่</div>
                  <div class="PC_Body1-R text-[#1F1D1F]">{{ assessment_count || '-' }}</div>
                </div>
                <div class="h-[47px] border-r-[1px] border-[#DFDCDD]"></div>
                <div class="flex flex-col">
                  <div class="PC_Body2-R text-[#7C7379]">วันที่ประเมิน</div>
                  <div class="PC_Body1-R text-[#1F1D1F]">
                    {{ $formatDate4(form.datetime) }}
                  </div>
                </div>
                <div class="w-full sm:w-fit flex items-center gap-[10px]">
                  <button v-if="(isOnline == true && isOffline == false)" @click="openLog()"
                    class="no-export h-[42px] w-fit text-[#1F1D1F] M border border-[#B7B2B5] px-[16px] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]">
                    ประวัติการแก้ไข
                  </button>
                  <button @click="changeMode(true)"
                    class="no-export h-[42px] w-[76px] text-white M bg-[#9B237B] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]">
                    แก้ไข
                  </button>
                </div>
              </div>
              <div v-if="(isOnline == true && isOffline == false)" class="no-export">
                <button @click="downloadPdf()"
                  class="h-[42px] w-fit text-[#1F1D1F] M border border-[#B7B2B5] px-[16px] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5] flex items-center justify-center gap-[6px]">
                  <DownloadIcon class="w-[20px] h-[20px] text-primary" /> ดาวน์โหลดรายงาน
                </button>
              </div>
            </div>
          </div>

          <div class="w-full border border-[#DFDCDD] border-dashed"></div>

          <!-- -- select team-- -->
          <div v-if="isEdit" class="max-w-[525px] w-full flex flex-col items-start gap-[2px]">
            <SelectBoxComponent :inputId="'allteam'" :keyValue="'id'" :keyName="'name'" :value="form.team_id"
              :options="allTeam" :label="'ทีมปฏิบัติการฉุกเฉิน'" :placeholder="'เลือกทีมเจ้าหน้าที่'"
              :warningMessage="errors.team_id" :allData="true" @update:modelValue="
                (res) => {
                  if (res) {
                    form.team_id = res?.id ?? '';
                    form.team_name = res?.name ?? '';
                  }
                }
              " />
          </div>

          <div v-else>
            <div class="PC_Body2-R text-[#7C7379]">ทีมปฏิบัติการฉุกเฉิน</div>
            <!-- {{ userProfile }} -->
            <div class="PC_Body1-R text-[#1F1D1F]">{{ teamName(form.team_id) }}</div>
          </div>
        </div>
        <!-- info -->
        <div class="w-full flex flex-col items-start gap-[20px]">
          <div class="w-full p-[10px] bg-[#FBEFF8]">
            <span class="PC_Body1-SB text-[#1F1D1F]"> 1. ข้อมูลพื้นฐาน </span>
          </div>
          <div class="w-full flex max-[500px]:flex-col items-start max-[500px]:items-center gap-[20px]">
            <div v-if="(isOnline == true || (isOffline == false || !isEdit) || !isEdit)"
              class="min-w-[100px] min-h-[100px] w-[100px] h-[100px] border-[1px] border-solid border-[#F2E7F9]">
              <img :src="userProfile.image || logo" alt="" />
            </div>
            <div class="w-full flex flex-col items-start gap-[24px]">
              <!-- {{ isEdit }} -->
              <div v-if="(isOffline == true && isEdit == false) || (isOnline == true && isOffline == false)"
                class="w-full flex flex-col items-start gap-[2px]">
                <div class="PC_Body2-R text-[#7C7379]">ชื่อผู้ประสบภัย</div>
                <div class="PC_Body1-R text-[#1F1D1F]">
                  <!-- {{ offLineData }} -->
                  {{
                    userProfile?.name ||
                    (offLineData?.detail?.assessment
                      ? `${offLineData.detail.assessment.prefix_name ?? ""} ${offLineData.detail.assessment.first_name ?? ""
                        } ${offLineData.detail.assessment.last_name ?? ""}`.trim()
                      : "-")
                  }}
                </div>
              </div>

              <div v-if="(isOffline == true && !isEdit) || (isOnline == true && isOffline == false)"
                class="w-full flex flex-col items-start gap-[2px]">
                <div class="PC_Body2-R text-[#7C7379]">วันเกิด</div>
                <div class="PC_Body1-R text-[#1F1D1F]">
                  <!-- {{ offLineData?.detail?.assessment?.birth_date }} -->
                  <template v-if="userProfile.birth_date">
                    {{
                      userProfile.birth_date
                        ? `${$formatDate4(userProfile.birth_date)} (${$CalAge(userProfile.birth_date)} ปี)`
                    : '-'
                    }}
                  </template>

                  <template v-else-if="offLineData?.detail?.assessment?.birth_date">
                    {{
                      `${$formatDate4(offLineData.detail.assessment.birth_date)}
                    (${$CalAge(offLineData.detail.assessment.birth_date)} ปี)`
                    }}
                  </template>

                  <template v-else>
                    -
                  </template>
                </div>
              </div>

              <div v-if="(isOffline == true && !isEdit) || (isOnline == true && isOffline == false)"
                class="w-full flex flex-col items-start gap-[2px]">
                <div class="PC_Body2-R text-[#7C7379]">เพศ</div>
                <div class="PC_Body1-R text-[#1F1D1F]">
                  <template v-if="userProfile?.gender">
                    {{
                      userProfile?.gender == 1
                        ? "ชาย"
                        : userProfile?.gender == 2
                          ? "หญิง"
                          : "-"
                    }}
                  </template>
                  <template v-else>
                    {{
                      offLineData?.detail?.assessment?.gender == 1
                        ? "ชาย"
                        : offLineData?.detail?.assessment?.gender == 2
                          ? "หญิง"
                          : "-"
                    }}
                  </template>

                </div>
              </div>

              <div v-if="(isOffline == true && !isEdit) || (isOnline == true && isOffline == false)"
                class="w-full flex flex-col items-start gap-[2px]">
                <div class="PC_Body2-R text-[#7C7379]">ที่อยู่ปัจจุบัน</div>
                <div class="PC_Body1-R text-[#1F1D1F]">
                  <template v-if="FullAddressAssesment">
                    {{ FullAddressAssesment || "-" }}
                  </template>
                  <template v-else-if="userProfile?.full_p_address_th && isEdit == true && !assessment_id ">
                    {{ userProfile?.full_p_address_th || "-" }}
                  </template>
                  <template v-else>
                    {{ offLineData?.detail?.assessment?.full_p_address_th || '-' }}
                  </template>
                </div>
              </div>

              <!-- ชื่อ -->
              <!-- {{ offLineData.detail }} -->
              <div v-if="isOffline == true && isEdit == true"
                class="w-full flex items-start gap-[24px] flex-wrap sm:flex-nowrap">
                <div class="w-full sm:w-fit min-w-[140px]">
                  <SelectBoxComponent :inputId="'prefix_id'" :keyValue="'id'" :keyName="'name'"
                    :value="form.prefix_id || offLineData?.detail?.assessment?.prefix_id" :options="allPrefix"
                    :disabled="offLineData.detail"
                    :label="'คำนำหน้า'" :placeholder="'เลือกคำนำหน้า'" :warningMessage="errors.prefix_id"
                    :alertWarningMessage="true" :allData="true" @update:modelValue="
                      (res) => {
                        form.prefix_id = res?.id ?? '';
                        form.prefix_name = res?.name ?? '';
                      }
                    " />
                </div>
                <div class="w-full">
                  <Input label="ชื่อ" placeholder="ชื่อ" v-model="form.first_name"
                    :warningMessage="errors.first_name" :disabled="offLineData.detail" />
                </div>
                <div class="w-full">
                  <Input label="นามสกุล" placeholder="นามสกุล" v-model="form.last_name"
                    :warningMessage="errors.last_name" :disabled="offLineData.detail" />
                </div>
              </div>
              <div v-if="isOffline == true && isEdit" class="w-full">
                <Input label="เบอร์โทรติดต่อ" placeholder="เบอร์โทรศัพท์" v-model="form.phone"
                  :warningMessage="errors.phone" 
                  @input="form.phone = $validateInputPhoneNum(form.phone)" />
                
                <span id="errphone" class="PC_Body2-R text-[#EB5554]">{{ errPhone }}</span>
              </div>

              <!-- วันเกิด -->
              <div v-if="isOffline == true && isEdit" class="w-full grid grid-cols-1 sm:grid-cols-2 gap-[14px]">
                <DatePicker2 label="วันเกิด" :id="'birthDate1'" placeholder="เลือกวันเดือนปี"
                  :modelValue="form.birth_date" :warningMessage="errors.birth_date"
                  @update:modelValue="(date) => selectBirthDate(date)" />

                <div v-if="isOffline == true && isEdit" class="flex items-end gap-[10px]">
                  <Input label="อายุ" placeholder="อายุ" v-model="form.age" :disabled="true" />
                  <span class="h-[35px]"> ปี </span>
                </div>
              </div>
              <SelectBoxComponent v-if="isOffline == true && isEdit" :inputId="'gender1'" :keyValue="'id'"
                :keyName="'name'" :options="Selector.genderOptions" :value="form.gender" :label="'เพศ'"
                :placeholder="'เลือกเพศ'" :warningMessage="errors.gender" @update:modelValue="
                  (res) => {
                    form.gender = res;
                  }
                " />

              <!-- ที่อยู่ -->
              <div v-if="isOffline == true && isEdit" class="w-full flex flex-col items-start gap-[16px]">
                <div class="flex items-center gap-[14px] flex-wrap">
                  <div class="PC_Body2-SB">ที่อยู่ปัจจุบัน</div>
                </div>
                <div class="w-full grid grid-cols-1 sm:grid-cols-3 items-start gap-[16px]">
                  <SelectBoxComponent :inputId="'provinceSelectorC'" :searchable="true" :allowEmpty="true"
                    :keyValue="'provinceCode'" :keyName="'provinceNameTh'" :value="form.c_province_code"
                    :placeholder="'เลือกจังหวัด'" :disabled="form.same_address || isOffline == false"
                    @update:modelValue="
                      (res) => {
                        form.c_province_code = res;
                        form.c_district_code = '';
                        form.c_subdistrict_code = '';
                        form.c_postal_code = '';
                        form.c_geography_id = '';
                      }
                    " />
                  <SelectBoxComponent :inputId="'districtSelectorC'" :searchable="true" :allowEmpty="true"
                    :keyValue="'districtCode'" :keyName="'districtNameTh'" :value="form.c_district_code"
                    :provinceCode="form.c_province_code" :placeholder="'เลือก เขต/อำเภอ'"
                    :warningMessage="errors.c_district_code" :disabled="form.same_address || isOffline == false"
                    @update:modelValue="
                      (res) => {
                        form.c_district_code = res;
                        form.c_subdistrict_code = '';
                        form.c_postal_code = '';
                        form.c_geography_id = '';
                      }
                    " />
                  <SelectBoxComponent :inputId="'subDistrictSelectorC'" :searchable="true" :allowEmpty="true"
                    :keyValue="'subdistrictCode'" :keyName="'subdistrictNameTh'" :value="form.c_subdistrict_code"
                    :districtCode="form.c_district_code" :placeholder="'เลือก แขวง/ตำบล'"
                    :warningMessage="errors.c_subdistrict_code" :disabled="form.same_address || isOffline == false"
                    :allData="true" @update:modelValue="
                      (res) => {
                        if (res && res.subdistrictCode) {
                          form.c_subdistrict_code = res.subdistrictCode;
                          form.c_postal_code = res.postalCode;
                          form.c_geography_id = res.id;
                        }
                      }
                    " />
                  <Input placeholder="รหัสไปรษณีย์" v-model="form.c_postal_code" :warningMessage="errors.c_postal_code"
                    :disabled="true" />
                  <div class="sm:col-span-2">
                    <Input placeholder="บ้านเลขที่, หมู่ที่, ซอย, และข้อมูลอื่นๆ" v-model="form.c_address" />
                    <!-- <AutoCompleteInput
                        placeholder="บ้านเลขที่, หมู่ที่, ซอย, และข้อมูลอื่นๆ"
                        v-model="form.c_address"
                        :fetcher="fetchAddress"
                        :itemText="
                          (it) => (typeof it === 'string' ? it : it?.name ?? '')
                        "
                        :itemValue="
                          (it) => (typeof it === 'string' ? it : it?.name ?? '')
                        "
                        notFoundText=""
                        :disabled="form.same_address"
                        @select="onPickAddress"
                      /> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- info -->

        <!-- 2. การเจ็บป่วย -->
        <!-- {{ form }} -->
        <div v-if="
          isEdit ||
          viewLists.trauma.length > 0 ||
          viewLists.infectious.length > 0 ||
          viewLists.urgent.length > 0 ||
          viewLists.otherMajor.length > 0
        " class="w-full flex flex-col items-start gap-[20px]">
          <div class="w-full p-[10px] bg-[#FBEFF8]">
            <label class="PC_Body1-SB text-[#1F1D1F]"> 2. Health events</label>
          </div>

          <!-- //อุบัติเหตุ (Trauma) -->
          <div v-if="isEdit || viewLists.trauma.length > 0"
            class="page-keep h-[30px] w-full flex items-center gap-[10px]">
            <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
            <span class="PC_Body1-SB text-[#1F1D1F] block h-[30px]">
              อุบัติเหตุ (Trauma)
            </span>
          </div>
          <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
            <CheckBox v-for="opt in traumaOptions" :key="opt.value" v-model="form.healthEvents.trauma"
              :value="opt.value" :label="opt.label" :disabled="!isEdit" />
          </div>
          <div v-else-if="viewLists.trauma.length > 0" class="flex flex-col items-start gap-[20px]">
            <div v-for="data in viewLists.trauma" :key="data.value" class="page-keep flex items-center fontSize14">
              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
              {{ data }}
            </div>
          </div>

          <!-- // โรคติดเชื้อ (Infectious disease) -->
          <div v-if="isEdit || viewLists.infectious.length > 0" class="page-keep w-full flex items-center gap-[10px] fontSize14">
            <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
            <span class="PC_Body1-SB text-[#1F1D1F]">
              โรคติดเชื้อ (Infectious disease)
            </span>
          </div>
          <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
            <CheckBox v-for="opt in infectiousOptions" :key="opt.value" v-model="form.healthEvents.infectious"
              :value="opt.value" :label="opt.label" :disabled="!isEdit" />
          </div>
          <div v-else-if="viewLists.infectious.length > 0" class="flex flex-col items-start gap-[20px]">
            <div v-for="data in viewLists.infectious" :key="data.value" class="page-keep flex items-center fontSize14">
              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
              {{ data }}
            </div>
          </div>

          <!-- //โรคฉุกเฉิน -->
          <div v-if="isEdit || viewLists.urgent.length > 0" class="page-keep w-full flex items-center gap-[10px]">
            <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
            <span class="PC_Body1-SB text-[#1F1D1F]">โรคฉุกเฉิน </span>
          </div>
          <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
            <CheckBox v-for="opt in urgentOptions" :key="opt.value" v-model="form.healthEvents.urgent"
              :value="opt.value" :label="opt.label" :disabled="!isEdit" />
          </div>
          <div v-else-if="viewLists.urgent.length > 0" class="flex flex-col items-start gap-[20px]">
            <div v-for="data in viewLists.urgent" :key="data.value" class="page-keep flex items-center fontSize14">
              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
              {{ data }}
            </div>
          </div>

          <!-- // โรคสำคัญอื่นๆ -->
          <div v-if="isEdit || viewLists.otherMajor.length > 0" class="page-keep w-full flex items-center gap-[10px]">
            <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
            <span class="PC_Body1-SB text-[#1F1D1F]"> โรคสำคัญอื่นๆ </span>
          </div>
          <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
            <CheckBox v-for="opt in otherMajorOptions" :key="opt.value" v-model="form.healthEvents.otherMajor"
              :value="opt.value" :label="opt.label" :disabled="!isEdit" />
          </div>
          <div v-else-if="viewLists.otherMajor.length > 0" class="flex flex-col items-start gap-[20px] fontSize14">
            <div v-for="data in viewLists.otherMajor" :key="data.value" class="page-keep flex items-center">
              <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
              {{ data }}
            </div>
          </div>
        </div>

        <!-- //หัตถการ -->
        <div v-if="isEdit || viewLists.procedures.length > 0 || image"
          class="page-keep w-full flex items-center gap-[10px]">
          <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
          <span class="PC_Body1-SB text-[#1F1D1F]"> หัตถการ </span>
        </div>

        <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
          <CheckBox v-for="opt in procedureOptions" :key="opt.value" v-model="form.healthEvents.procedures"
            :value="opt.value" :label="opt.label" :disabled="!isEdit" />
        </div>
        <div v-else-if="viewLists.procedures.length > 0" class="flex flex-col items-start gap-[20px] fontSize14">
          <div v-for="data in viewLists.procedures" :key="data.value" class="page-keep flex items-center">
            <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
            {{ data }}
          </div>
        </div>

        <div v-if="isEdit || image" class="flex flex-col items-center gap-[8px]">
          <div v-if="isEdit" class="w-full flex items-center gap-[10px]">
            <span class="PC_Body1-SB text-[#1F1D1F]"> แนบรูป </span>
          </div>
          <UploadImage2 
          v-model:image="image" 
          @update:fileSizeMB="
                (res)=>{
                  imageSize = res;
                }" 
          :fileSizeMB="imageSize" 
          :editable="isEdit" :type="1" 
          @update:image="(res) => {
            image = res
            console.log(res)
          }" />
        </div>
        <!-- //ผลการรักษา -->
        <div v-if="isEdit || viewLists.outcomes.length > 0" class="page-keep w-full flex items-center gap-[10px]">
          <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
          <span class="PC_Body1-SB text-[#1F1D1F]">ผลการรักษา</span>
        </div>
        <div v-if="isEdit" class="flex flex-col items-start gap-[20px]">
          <CheckBox v-for="opt in outcomeOptions" :key="opt.value" v-model="form.healthEvents.outcomes"
            :value="opt.value" :label="opt.label" :disabled="!isEdit" />
        </div>
        <div v-else-if="viewLists.outcomes.length > 0" class="flex flex-col items-start gap-[20px]">
          <div v-for="data in viewLists.outcomes" :key="data.value" class="page-keep flex items-center fontSize14">
            <div class="w-[4px] h-[4px] bg-[#A8A3A6] rounded-full ml-2.5 mr-3.5 mt-20-pdf"></div>
            {{ data }}
          </div>
        </div>
      </div>

      <!-- <div v-if="!isEdit" class="w-full border border-[#DFDCDD] border-dashed"></div> -->

      <div v-if="(!isEdit && isOnline == true) && isOffline == false" class="w-full flex flex-col gap-[20px]">
        <div v-if="!isEdit" class="page-keep w-full flex items-center gap-[10px]">
          <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
          <span class="PC_Body1-SB text-[#1F1D1F]">ผู้ลงข้อมูล</span>
        </div>

        <div v-if="!isEdit" class="flex flex-col items-start gap-[20px] fontSize14">
          {{ created_name || "-" }}
        </div>
      </div>

      <div v-if="isEdit" class="w-full flex justify-end items-center gap-[10px]">
        <ButtonComponent :label="'ยกเลิก'" :bClass="'btn_shadow--cancel'" @clicked="cancelAssessment" />

        <ButtonComponent v-if="isOnline == true" :label="'บันทึก'" :bClass="'btn_shadow--save'" :disabled="!isEdit"
          @clicked="takeAssessment" />
        <ButtonComponent v-if="isOnline == false" :label="'บันทึก'" :bClass="'btn_shadow--save'" :disabled="!canSave"
          @clicked="takeAssessment" />
        <!-- :disabled="!canSave" -->
      </div>
    </div>

    <!-- <div v-if="!isEdit" class="w-full border border-[#DFDCDD] border-dashed"></div>

    <div v-if="!isEdit" class="page-keep w-full flex items-center gap-[10px]">
      <div class="w-[4px] h-[30px] bg-[#EECCE7]"></div>
      <span class="PC_Body1-SB text-[#1F1D1F]">ผู้ลงข้อมูล</span>
    </div>

    <div v-if="!isEdit" class="pdf-sentinel flex flex-col items-start gap-[20px]">
      {{ created_name || "-" }}
    </div> -->

    <!-- <div v-if="isEdit" class="w-full flex justify-end items-center gap-[10px]">
      <ButtonComponent
        :label="'ยกเลิก'"
        :bClass="'btn_shadow--cancel'"
        @clicked="cancelAssessment"
      />
      <ButtonComponent
        :label="'บันทึก'"
        :bClass="'btn_shadow--save'"
        :disabled="!isEdit"
        @clicked="takeAssessment"
      />
    </div> -->
    <LogHistoryAssessmentModal ref="LogHistoryAssessmentModalRef" />
  </div>
  <!-- </div> -->

  <!-- </div> -->
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed, nextTick } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import logo from '@/assets/images/User.png'
// import {
//   addOfflineAssessment,
//   getOfflineAssessments,
//   updateOfflineAssessment,
// } from "@/components/Utilities/javascripts/offlineAssessment";
import {
  getOfflineAssessments,
  addOfflineAssessment,
  updateOfflineAssessment,
  deleteOfflineAssessment,
  clearOfflineAssessments,
} from "@/components/Utilities/javascripts/offlineAssessmentStorage";

import axios from "axios";
import html2pdf from "html2pdf.js";
import { useRoute, useRouter } from "vue-router";
import { usePopulationStore } from "@/pinia/population";
import { includes } from "lodash";
import { useTeamStore } from "@/pinia/team";
import { storeToRefs } from "pinia";
import { inject } from "vue";
import { useOnlineStatus } from "@/composables/useOnlineStatus";
import { Selector } from "@/components/Utilities/javascripts/constants";
import { usePrefixStore } from "@/pinia/prefix";
import { useAuthStore } from "@/pinia/authStore";
// === ใช้เมื่อต้องประกอบที่อยู่แบบ type3 ===
import { resolveAddress } from "@/components/Utilities/javascripts/addressResolver";

const pdfRef = ref(null);
const route = useRoute();
const router = useRouter();

const { $buildFormData } = useGlobals();
const userPopulation = usePopulationStore();
const teamStore = useTeamStore();
const { allTeam } = storeToRefs(teamStore);
const prefixStore = usePrefixStore();
const { allPrefix } = storeToRefs(prefixStore);
const statusModal = inject("statusModal");
const { $CalAge } = useGlobals();
const LogHistoryAssessmentModalRef = ref(null);
const { isOnline, checkNow } = useOnlineStatus();

const auth = useAuthStore();
const { userData } = storeToRefs(auth);

const toArray = (v) => (Array.isArray(v) ? v : []);
const allPrefixView = computed(() => toArray(allPrefix.value));

const canSave = ref(false);
const profileData = ref({});
const offLineData = ref({});
const FullAddressAssesment = ref()

/** ====== STATE หลักของฟอร์ม ====== */
let input = {
  id: "",
  prefix_id: "",
  prefix_name: "",
  first_name: "",
  last_name: "",
  birth_date: "",
  age: "",
  gender: "",
  phone: "",

  p_province_code: "",
  p_district_code: "",
  p_subdistrict_code: "",
  p_postal_code: "",
  p_address: "",
  p_geography_id: "",
  same_address: "",
  c_province_code: "",
  c_district_code: "",
  c_subdistrict_code: "",
  c_postal_code: "",
  c_address: "",
  c_geography_id: "",
  full_p_address_th: "",
  full_p_address_en: "",

  datetime: "",
  pregnancy: 0,
  max_capacity: "",
  population_id: "",
  type: 1,
  team_id: null,
  team_name: "",

  healthEvents: {
    trauma: [],
    infectious: [],
    urgent: [],
    otherMajor: [],
    procedures: [],
    outcomes: [],
  },
};

const form = reactive({
  ...input,
  datetime: new Date(),
  healthEvents: { ...input.healthEvents },
});
const errors = ref({ ...input, healthEvents: { ...input.healthEvents } });
const created_name = ref("");
const assessment_count = ref("");
const item = ref({});
const isEdit = ref(false);
const isOffline = ref(false);
const lastLoaded = ref(null);
const selectedTeam = ref(null);
const image = ref("");
const imageSize = ref("");

// เก็บสำเนาค่าเดิมของฟอร์มเพื่อใช้ restore ตอน cancel
const pristineForm = ref(null);
const exportPlainForm = () => ({
  datetime: form.datetime ? new Date(form.datetime) : "",
  pregnancy: form.pregnancy,
  max_capacity: form.max_capacity,
  population_id: form.population_id,
  type: form.type,
  team_id: form.team_id,
  healthEvents: {
    trauma: [...(form.healthEvents?.trauma ?? [])],
    infectious: [...(form.healthEvents?.infectious ?? [])],
    urgent: [...(form.healthEvents?.urgent ?? [])],
    otherMajor: [...(form.healthEvents?.otherMajor ?? [])],
    procedures: [...(form.healthEvents?.procedures ?? [])],
    outcomes: [...(form.healthEvents?.outcomes ?? [])],
  },
  full_p_address_th: form.full_p_address_th,
  full_p_address_en: form.full_p_address_en,
});

const traumaOptions = [
  {
    value: "severeHeadSpineInjury",
    label: "บาดเจ็บบริเวณศีรษะ/กระดูกสันหลังอย่างรุนแรง",
  }, //a1
  { value: "severeTorsoInjury", label: "บาดเจ็บบริเวณลำตัวอย่างรุนแรง" }, //a2
  { value: "upperLimbInjury", label: "บาดเจ็บบริเวณส่วนปลายแขนขา" }, //a3
  { value: "moderateInjuries", label: "บาดเจ็บปานกลาง" }, //a4
  { value: "minorInjuries", label: "บาดเจ็บเล็กน้อย" }, //a5
];

const infectiousOptions = [
  { value: "acuteRespInfection", label: "การติดเชื้อทางเดินหายใจเฉียบพลัน" }, //b1
  { value: "acuteDiarrhea", label: "ท้องเสียเฉียบพลัน" }, //b2
  { value: "acuteBloodyDiarrhea", label: "ท้องเสียเป็นเลือดเฉียบพลัน" }, //b3

  { value: "acuteJaundice", label: "โรคดีซ่านเฉียบพลัน" }, //b4
  { value: "suspectedMeasles", label: "สงสัยเป็นโรคหัด (Measles)" }, //b5
  { value: "suspectedMeningitis", label: "สงสัยเยื่อหุ้มสมองอักเสบ" }, //b6
  { value: "suspectedTetanus", label: "สงสัยบาดทะยัก" }, //b7
  { value: "acuteParalysis", label: "อัมพาตเฉียบพลัน" }, //b8
  { value: "acuteDengueFever", label: "ไข้เลือดออกเฉียบพลัน" }, //b9
  { value: "feverOfUnknownCause", label: "ไข้ไม่ทราบสาเหตุ" }, //b10
];

const urgentOptions = [
  {
    value: "emergencySurgicalDisease",
    label: "โรคทางศัลยกรรมฉุกเฉิน (ไม่ใช่การบาดเจ็บ)",
  }, //c1
  { value: "emergencyMedicalDiseases", label: "โรคทางอายุรกรรมฉุกเฉิน (ไม่ติดเชื้อ)" }, //c2
];

const otherMajorOptions = [
  { value: "dermatologic", label: "โรคผิวหนัง" }, //d1
  { value: "acuteMentalHealthProblems", label: "ปัญหาสุขภาพจิตเฉียบพลัน" }, //d2
  { value: "obstetricComplications", label: "ภาวะแทรกซ้อนทางสูติกรรม" }, //d3
  { value: "severeAcuteMalnutrition", label: "ภาวะทุพโภชนาการเฉียบพลันรุนแรง (SAM)" }, //d4
  {
    value: "otherDiagnosesNotListedAbove",
    label: "การวินิจฉัยอื่น ๆ ที่ไม่ได้ระบุไว้ข้างต้น",
  }, //d5
];

const procedureOptions = [
  { value: "injectDrug", label: "ฉีดยา" }, //e1
  { value: "woundCare", label: "ทำแผล" }, //e2
  { value: "minorSurgeryIncludingSuturing", label: "ผ่าตัดเล็กรวมเย็บแผล" }, //e3
];

const outcomeOptions = [
  { value: "discharge", label: "Discharge (OPD)" }, //f1
  { value: "admit", label: "Admit (IPD)" }, //f2
  { value: "refer", label: "Refer" }, //f3
];

const assessment_id = ref("");
const population_id = ref("");

const userProfile = ref({});

const isURL = (str) => {
  try {
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};

const pdfUrl = ref({});
const imageUrl = ref({});
const errPhone = ref(null);

function computeErrorsSnapshot() {
  const e = errors.value;
  let ok = true;

  if (isEmpty(form.team_id)) {
    ok = false;
    // e.prefix_id = "โปรดเลือกคำนำหน้า";
  }

  if (isEmpty(form.prefix_id)) {
    ok = false;
    // e.prefix_id = "โปรดเลือกคำนำหน้า";
  }
  if (isEmpty(form.first_name)) {
    ok = false;
    // e.first_name = "โปรดกรอกชื่อ";
  }
  if (isEmpty(form.last_name)) {
    ok = false;
    // e.last_name = "โปรดกรอกนามสกุล";
  }
  if (isEmpty(form.phone)) {
    ok = false;
    // e.phone = "โปรดกรอกเบอร์โทรศัพท์";
  }

  return { ok, errors: e };
}

watch(
  () => form.birth_date,
  (newVal) => {
    form.age = $CalAge(newVal);
  }
);

watch(
  form,
  () => {
    if (isOnline.value == false) {
      const { ok, errors: snap } = computeErrorsSnapshot();
      errors.value = snap; // โครงครบ จึงไม่ undefined แน่นอน
      canSave.value = ok;
    }
  },
  { deep: true }
);

watch(
  () => offLineData?.value?.detail?.assessment,
  (val) => {
    if (!val) return;

    form.prefix_id = val.prefix_id ?? '';
    form.prefix_name = val.prefix_name ?? '';
    form.first_name = val.first_name ?? '';
    form.last_name = val.last_name ?? '';
    form.birth_date = val.birth_date ?? '';
    form.age = val.age ?? '';
    form.gender = val.gender ?? '';
    form.phone = val.phone ?? '';

    // ที่อยู่ปัจจุบัน
    form.c_province_code = val.c_province_code ?? '';
    form.c_district_code = val.c_district_code ?? '';
    form.c_subdistrict_code = val.c_subdistrict_code ?? '';
    form.c_postal_code = val.c_postal_code ?? '';
    form.c_address = val.c_address ?? '';
    form.c_geography_id = val.c_geography_id ?? '';

    // ที่อยู่ตามทะเบียน (ถ้ามี)
    form.p_province_code = val.p_province_code ?? '';
    form.p_district_code = val.p_district_code ?? '';
    form.p_subdistrict_code = val.p_subdistrict_code ?? '';
    form.p_postal_code = val.p_postal_code ?? '';
    form.p_address = val.p_address ?? '';
    form.p_geography_id = val.p_geography_id ?? '';

    form.same_address = val.same_address ?? false;
  },
  { immediate: true }
);

// watch(isOnline, (newVal) => {
//   console.log("online changed:", newVal ? "ONLINE" : "OFFLINE");
//   if(route.params.populationFormId === "offline" && isOnline.value == true){
//     router.push('/dashboard')
//   }
// });

const initPage = async () => {
  // ของเดิมที่อยู่ใน onMounted
  if (!checkNow() || route.params.populationFormId === "offline") {
    isOffline.value = true;
    const id = route.params.assessmentFormId;
    console.log('route.params', route.params);

    console.log("Offline mode for assessment id:", id);
    if (id && id !== "null" && id !== "undefined") {
      assessment_id.value = id;
      offLineData.value = await fetchAssessment(id, true);
      console.log("offLineData:", offLineData.value);
    } else {
      // isEdit.value = true;
    }
    //   teamStore
    // .getAllTeam()
    // .then((res) => {
    //   // console.log('res :: ', res);
    // })
    // .catch((err) => {});

    // const populationFormId = computed(() => route.params.populationFormId)      // string
    // const assessmentFormId = computed(() => route.params.assessmentFormId)

    // prefixStore.getAllPrefix();
    // profileData.value = await useAuthStore().getProfile();

  }
};


onMounted(async () => {
  // if(route.params.populationFormId === "offline" && isOnline.value == true){
  //   router.push('/dashboard')
  //   return
  // }
  if (route.query.edit === 'true') {
    changeMode(true);
  }
  if (!checkNow() || route.params.populationFormId === "offline") {
    isOffline.value = true;
    const id = route.params.assessmentFormId;
    console.log("Offline mode for assessment id:", id);

    teamStore.loadTeamFromLocal()
    // console.log('allTeam:', teamStore.allTeam)
    // console.log('allTeamerherh', allTeam.value)
    allTeam.value = JSON.parse(localStorage.getItem('allTeam') || '[]')

    if (id && id !== "null" && id !== "undefined") {
      assessment_id.value = id;
      offLineData.value = await fetchAssessment(id, true);
      console.log("offLineData:", offLineData.value);
    } else {
      isEdit.value = true;
    }
    teamStore
      .getAllTeam()
      .then((res) => {
        // console.log('res :: ', res);
      })
      .catch((err) => { });
    


     

    // const populationFormId = computed(() => route.params.populationFormId)      // string
    // const assessmentFormId = computed(() => route.params.assessmentFormId)

    prefixStore.getAllPrefix();
    profileData.value = await useAuthStore().getProfile();
    return
  }

  teamStore
    .getAllTeam()
    .then((res) => {
      // console.log('res :: ', res);
    })
    .catch((err) => { });

  // const populationFormId = computed(() => route.params.populationFormId)      // string
  // const assessmentFormId = computed(() => route.params.assessmentFormId)

  prefixStore.getAllPrefix();
  profileData.value = await useAuthStore().getProfile();

  if (route.params.populationFormId) {
    population_id.value = route.params.populationFormId;

    userPopulation
      .getPopulationById(route.params.populationFormId)
      .then((res) => {
        if (res.data.code == 200) {
          userProfile.value = res.data.data;
          // console.log("res.data.data", res.data.data);
        }
      })
      .catch((err) => { });
  }
  // console.log('populationFormId ::: ', route.params.populationFormId);
  // console.log('assessmentFormId ::: ', route.params.assessmentFormId);
  if (route.params.assessmentFormId !== "null") {
    assessment_id.value = route.params.assessmentFormId;
    offLineData.value = fetchAssessment(route.params.assessmentFormId);
  } else {
    isEdit.value = true;
  }
});

const openLog = () => {
  LogHistoryAssessmentModalRef.value.openModal(assessment_id.value);
};
const restoreFromSnapshot = () => {
  if (!pristineForm.value) return;
  const snap = pristineForm.value;
  // restore ค่า root
  form.datetime = snap.datetime ? new Date(snap.datetime) : "";
  form.pregnancy = snap.pregnancy;
  form.max_capacity = snap.max_capacity;
  form.population_id = snap.population_id;
  form.type = snap.type;
  form.team_id = snap.team_id;
  // restore ค่า healthEvents (array ต่าง ๆ)
  form.healthEvents.trauma = [...(snap.healthEvents?.trauma ?? [])];
  form.healthEvents.infectious = [...(snap.healthEvents?.infectious ?? [])];
  form.healthEvents.urgent = [...(snap.healthEvents?.urgent ?? [])];
  form.healthEvents.otherMajor = [...(snap.healthEvents?.otherMajor ?? [])];
  form.healthEvents.procedures = [...(snap.healthEvents?.procedures ?? [])];
  form.healthEvents.outcomes = [...(snap.healthEvents?.outcomes ?? [])];

  form.full_p_address_th = s?.full_p_address_th;
  form.full_p_address_en = s?.full_p_address_en;
};
const takeSnapshot = () => {
  pristineForm.value = exportPlainForm();
};
const changeMode = (editing) => {
  if (editing) {
    // จะเริ่มแก้ → เก็บ snapshot ค่า ณ ตอนกดแก้
    takeSnapshot();
  }
  isEdit.value = editing;
};
const teamName = (val) => {
  // console.log('allTeam : ', allTeam);
  if (allTeam.value && form.team_id) {
    let _team = allTeam.value.find((el) => el.id == val);
    if (_team) {
      return _team.name;
    } else {
      if (form.team_name) {
        return form.team_name;
      } else {
        return "-";
      }
    }
  } else {
    return "-";
  }
};
const formatDateYMD = (d) => {
  try {
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  } catch {
    return "";
  }
};

// ---------- helpers เดิมใช้ได้ต่อ ----------
const toBits = (options, selectedValues) => {
  const set = new Set((selectedValues || []).map((v) => String(v)));
  return options.map((o) => Number(set.has(String(o.value))));
};
const fromBits = (options, bits) =>
  options.filter((o, i) => bits?.[i]).map((o) => o.value);
const pickLabels = (options, selected) =>
  options.filter((o) => (selected || []).includes(o.value)).map((o) => o.label);

const normalizeBits = (bits, len) => {
  const arr = Array.isArray(bits) ? bits.map((x) => (Number(x) ? 1 : 0)) : [];
  if (arr.length < len) return arr.concat(Array(len - arr.length).fill(0));
  if (arr.length > len) return arr.slice(0, len);
  return arr;
};

// ---------- view lists (สำหรับหน้าแสดงผล) ----------
const viewLists = computed(() => ({
  trauma: pickLabels(traumaOptions, form.healthEvents.trauma),
  infectious: pickLabels(infectiousOptions, form.healthEvents.infectious),
  urgent: pickLabels(urgentOptions, form.healthEvents.urgent),
  otherMajor: pickLabels(otherMajorOptions, form.healthEvents.otherMajor),
  procedures: pickLabels(procedureOptions, form.healthEvents.procedures),
  outcomes: pickLabels(outcomeOptions, form.healthEvents.outcomes),
}));

// ---------- buildDetail() กลับเป็น [{a1:true},{...}] ----------
const buildDetail = () => [
  ...sectionToKVArray("a", traumaOptions, form.healthEvents.trauma), // a1..a5
  ...sectionToKVArray("b", infectiousOptions, form.healthEvents.infectious), // b1..b10
  ...sectionToKVArray("c", urgentOptions, form.healthEvents.urgent), // c1..c2
  ...sectionToKVArray("d", otherMajorOptions, form.healthEvents.otherMajor), // d1..d5
  ...sectionToKVArray("e", procedureOptions, form.healthEvents.procedures), // e1..e3
  ...sectionToKVArray("f", outcomeOptions, form.healthEvents.outcomes), // f1..f3
];

const sectionToKVArray = (prefix, options, selectedValues) => {
  const set = new Set((selectedValues || []).map((v) => String(v)));
  return options.map((_, idx) => {
    const key = `${prefix}${idx + 1}`;
    return { [key]: set.has(String(options[idx].value)) };
  });
};
const kvArrayToMap = (arr) => Object.assign({}, ...(Array.isArray(arr) ? arr : []));
const kvToSelected = (prefix, options, kvMap) =>
  options
    .filter((_, idx) => {
      const key = `${prefix}${idx + 1}`;
      const v = kvMap[key];

      // แปลงค่าที่มาจาก backend ให้เป็น boolean แบบละเอียด
      const isOn = v === true || v === "true" || v === 1 || v === "1";

      return isOn;
    })
    .map((o) => o.value);

// ---------- โหลดจาก API (รองรับรูปแบบใหม่ [{a1:true},...]) ----------
const populateFormFromApi = (api = {}) => {
  const detail = api?.detail || {};
  console.log("populateFormFromApi : ", detail);

  const assessArr = Array.isArray(detail.assessment_bits) ? detail.assessment_bits : [];
  FullAddressAssesment.value = detail?.assessment?.full_p_address_th || null
  const kvMap = kvArrayToMap(assessArr);

  // วันที่ / header
  if (api.datetime) form.datetime = new Date(api.datetime);
  if (api.type !== undefined) form.type = api.type;
  if (api.population_id !== undefined) form.population_id = api.population_id;
  if (api.team_id !== undefined) form.team_id = api.team_id;
  if (api.team_name !== undefined) form.team_name = api.team_name;
  if (detail.pregnancy !== undefined && detail.pregnancy !== null) {
    form.pregnancy = detail.pregnancy;
  }

  // healthEvents (แปลงกลับเป็นอาเรย์ของ value สำหรับ UI)
  form.healthEvents.trauma = kvToSelected("a", traumaOptions, kvMap); // a1..a5
  form.healthEvents.infectious = kvToSelected("b", infectiousOptions, kvMap); // b1..b10
  form.healthEvents.urgent = kvToSelected("c", urgentOptions, kvMap); // c1..c2
  form.healthEvents.otherMajor = kvToSelected("d", otherMajorOptions, kvMap); // d1..d5
  form.healthEvents.procedures = kvToSelected("e", procedureOptions, kvMap); // e1..e3
  form.healthEvents.outcomes = kvToSelected("f", outcomeOptions, kvMap); // f1..f3
};

// ยิง API แล้วเติมค่า (รองรับรูปแบบที่คุณส่งตัวอย่างมา)
async function fetchAssessment(id, offline = false) {
  try {
    if (offline) {
      const list = await getOfflineAssessments();

      const record = list.find((item) => String(item.id) === String(id));

      if (!record) {
        console.warn("No offline assessment found for id:", id);
        return null;
      }

      const payload = record.data || record;
      // offLineData.value = payload
      console.log('payload', payload);

      created_name.value = payload?.created_name || record.name || "";
      assessment_count.value = payload?.data?.assessment_count;
      image.value = payload.image;
      imageSize.value = payload.image_size;

      populateFormFromApi(payload || {});
      // isEdit.value = false;
      // if (route.query.edit === 'true') {
      //   changeMode(true);
      // }
      takeSnapshot();

      return payload;
    }
    const { data } = await axios.get("/assessment/" + id);
    const payload = data && typeof data === "object" && data.data ? data.data : data;
    // console.log("payload : ", payload);

    pdfUrl.value = payload.download.pdf_download;
    imageUrl.value = payload.download.image_download;
    console.log("PDF URL:", pdfUrl.value);

    created_name.value = payload.created_name;
    assessment_count.value = payload.count;
    image.value = payload.image;
    imageSize.value = payload.image_size;
    populateFormFromApi(payload || {});
    // isEdit.value = false;
    if (route.query.edit === 'true') {
    changeMode(true);
  }
    // ค่าโหลดจาก API คือฐานข้อมูลเดิมของหน้า → snapshot ไว้
    takeSnapshot();
    return payload;
  } catch (e) {
    console.error("fetchAssessment error:", e);
    return null;
  }
}

// keep DatePicker in sync
const selectCreateDate = (date) => {
  form.datetime = date;
};

// cancel
const cancelAssessment = () => {
  if (route.query.from) {
    router.push(route.query.from)
    return
  }

  router.back()
}

const isNum = (v) => v !== "" && v !== null && v !== undefined && !isNaN(Number(v));

const isEmpty = (v) =>
  v === "" ||
  v === null ||
  v === undefined ||
  (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0);

const clearErrors = () => {
  for (const k in errors.value) {
    if (errors.value[k] && typeof errors.value[k] === "object") {
      for (const c in errors.value[k]) errors.value[k][c] = "";
    } else {
      errors.value[k] = "";
    }
  }
};

const validateForm = () => {
  clearErrors();
  let ok = true;

  if (!form.datetime || isNaN(new Date(form.datetime).getTime())) {
    ok = false;
    errors.value.datetime = "โปรดเลือกวันที่ประเมิน";
  }
  if (isEmpty(form.team_id)) {
    ok = false;
    errors.value.team_id = "เลือกทีมเจ้าหน้าที่";
  }
  return ok;
};
// save
const takeAssessment = async () => {
  if (!validateForm()) {
    console.warn("ฟอร์มไม่ผ่านการตรวจสอบ");
    return;
  }
  // console.log('form', form);
  // console.log('userprofile', userProfile?.value?.full_p_address_th)

  if (form?.phone?.length < 10 && isOffline.value == true) {
    errPhone.value = "โปรดกรอกเบอร์โทรศัพท์ที่ติดต่อ ให้ถูกต้อง";

    nextTick(() => {
      document
        .getElementById("errphone")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    return;
  } else {
    errPhone.value = "";
  }


  const result = resolveAddress({
    provinceCode: form.c_province_code,
    districtCode: form.c_district_code,
    subdistrictCode: form.c_subdistrict_code,
  });

  const safe = (v) => v ? v : '';

  const isBangkok = String(form.c_province_code) === '10';

  const subTh = safe(result.subdistrictTh);
  const distTh = safe(result.districtTh);
  const provTh = safe(result.provinceTh);
  const subEn = safe(result.subdistrictEn);
  const distEn = safe(result.districtEn);
  const provEn = safe(result.provinceEn);
  const zip = safe(result.postalCode);

  form.full_p_address_th = isBangkok
    ? `${form.c_address || ''}${subTh ? ` แขวง ${subTh}` : ''}${distTh ? ` เขต ${distTh}` : ''} จ.กรุงเทพมหานคร${zip ? ` ${zip}` : ''}`
    : `${form.c_address || ''}${subTh ? ` ต.${subTh}` : ''}${distTh ? ` อ.${distTh}` : ''}${provTh ? ` จ.${provTh}` : ''}${zip ? ` ${zip}` : ''}`;

  form.full_p_address_en = isBangkok
    ? `${form.c_address || ''}${subEn ? ` ${subEn}` : ''}${distEn ? ` ${distEn}` : ''} Bangkok${zip ? ` ${zip}` : ''}`
    : `${form.c_address || ''}${subEn ? ` ${subEn}` : ''}${distEn ? ` ${distEn}` : ''}${provEn ? ` ${provEn}` : ''}${zip ? ` ${zip}` : ''}`;


  const bits = buildDetail();
  let payload;
  const fullForm = {
    ...form,
    full_p_address_th: userProfile?.value?.full_p_address_th || form.full_p_address_th,
    full_p_address_en: userProfile?.value?.full_p_address_en || form.full_p_address_en,
  };

  if (isOnline == true) {
    payload = {
      image: image.value,
      datetime: formatDateYMD(form.datetime),
      population_id: population_id?.value ?? population_id,
      type: form.type,
      detail: {
        pregnancy: form.pregnancy,
        assessment: buildDetail(),
      },
      district_id: userProfile.value.p_district_code,
      team_id: form.team_id,
      team_name: form.team_name,
    };
  } else {
    payload = {
      first_name: form.first_name,
      last_name: form.last_name,
      image: image.value,
      image_size: imageSize.value,
      datetime: formatDateYMD(form.datetime),
      population_id: population_id?.value ?? population_id,
      type: form.type,
      assessment_count: '-',
      detail: {
        pregnancy: form.pregnancy,
        assessment: fullForm,
        assessment_bits: bits,
      },
      district_id: userProfile.value.p_district_code || null,
      team_id: form.team_id,
      team_name: form.team_name,
      create_by: userData.value?.fullname || "-",
    };
  }

  let api_path;
  if (assessment_id.value) {
    payload.id = assessment_id.value;
    payload = isURL(payload.image) ? { ...payload, image: undefined } : { ...payload };
    api_path = "/assessment/" + assessment_id.value;
  } else {
    api_path = "/assessment";
  }

  // if (payload.image && !isURL(payload.image)) {
  //     payload.image = payload.image;
  //   } else {
  //     delete payload.image;
  //   }

  if (payload.image === undefined) {
    delete payload.image;
  }

  let formData = new FormData();
  const body = $buildFormData(formData, payload);

  // console.log('payload (submit):', payload)
  if (isOffline.value == true) {
    if (payload.image instanceof File || payload.image instanceof Blob) {
      payload.image = await fileToBase64(payload.image);
    }

    if (assessment_id.value) {
      const cleanPayload = deepClean(payload);
      const item = await updateOfflineAssessment(assessment_id.value, cleanPayload, undefined , false);
      isEdit.value = false;
      assessment_id.value = item.id;
      console.log("บันทึกแบบประเมินออฟไลน์:", item);
      image.value = item.data.image;
      assessment_count.value = item.data.assessment_count;
      offLineData.value = await fetchAssessment(item.id, true);
      // await initPage();
      // router.push({
      //   name: "offline-assessment",
      //   query: {
      //     success: "1",
      //   },
      // });
      statusModal.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
        timeout: 5000,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
      });
      return;
    } else {
      console.log("wdwd1", payload);
      const cleanPayload = deepClean(payload);
      const item = await addOfflineAssessment(cleanPayload, cleanPayload.type);
      isEdit.value = false;
      assessment_id.value = item.id;
      console.log("บันทึกแบบประเมินออฟไลน์:", item);
      image.value = item.data.image;
      assessment_count.value = item.data.assessment_count;
      offLineData.value = await fetchAssessment(item.id, true);
      // await initPage();

      // router.push({
      //   name: "offline-assessment",
      //   query: {
      //     success: "1",
      //   },
      // });
      statusModal.value.openModal("success", {
        header: "ดำเนินการสำเร็จ !",
        subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
        closeButtonText: "ปิดหน้าต่าง",
        timeout: 5000,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
      });
      return;
    }
  } else {
    console.log('body', payload);

    axios.post(api_path, body).then(async (res) => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // เลื่อนแบบนุ่มนวล ถ้าไม่ต้องการก็ตัดออก
      });
      // console.log('res : ', res);
      if (res.data.code == 200) {
        isEdit.value = false;
        assessment_id.value = res.data.data.id;
        assessment_count.value = res.data.data.count;
        created_name.value = res.data.data.created_name;
        image.value = res.data.data.image;
        imageSize.value = res.data.data.image_size;
        statusModal.value.openModal("success", {
          header: "ดำเนินการสำเร็จ !",
          subHeader: "ระบบได้ บันทึกข้อมูล สำเร็จ",
          closeButtonText: "ปิดหน้าต่าง",
          timeout: 5000,
        });

        await fetchAssessment(res.data.data.id);
      } else {
        statusModal.value.openModal("error", {
          header: "เกิดความผิดพลาด !",
          subHeader: err.response.data.message,
          closeButtonText: "ปิดหน้าต่าง",
        });
      }
    });
  }
};

function deepClean(obj) {
  return JSON.parse(JSON.stringify(obj, (key, value) => {
    if (typeof value === "function") return undefined;
    if (value instanceof File) return undefined;
    if (value instanceof Blob) return undefined;
    if (value === undefined) return null;
    return value;
  }));
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const downloadPdf = async () => {
  try {
    const timestamp = Date.now(); // millisecond
    const baseName = `report_${timestamp}`;

    // ===== PDF =====
    if (pdfUrl.value) {
      const pdfResp = await axios.get(pdfUrl.value, { responseType: "blob" });
      const pdfBlob = new Blob([pdfResp.data], { type: "application/pdf" });

      const pdfLink = document.createElement("a");
      const pdfUrlObj = window.URL.createObjectURL(pdfBlob);
      pdfLink.href = pdfUrlObj;
      pdfLink.setAttribute("download", `${baseName}.pdf`);

      document.body.appendChild(pdfLink);
      pdfLink.click();
      pdfLink.remove();
      window.URL.revokeObjectURL(pdfUrlObj);

      console.log("PDF downloaded!");
    }

    // ===== IMAGE =====
    if (imageUrl.value) {
      const imgResp = await axios.get(imageUrl.value, { responseType: "blob" });

      // เดานามสกุลไฟล์จาก content-type
      const contentType = imgResp.headers["content-type"];
      const ext = contentType?.split("/")[1] || "png";

      const imgBlob = new Blob([imgResp.data], { type: contentType || "image/png" });

      const imgLink = document.createElement("a");
      const imgUrlObj = window.URL.createObjectURL(imgBlob);
      imgLink.href = imgUrlObj;
      imgLink.setAttribute("download", `${baseName}.${ext}`);

      document.body.appendChild(imgLink);
      imgLink.click();
      imgLink.remove();
      window.URL.revokeObjectURL(imgUrlObj);

      console.log("Image downloaded!");
    }
  } catch (error) {
    console.error("Error downloading files:", error);
  }
};

// const el = pdfRef.value;
//   const opt = {
//     margin: [10, 10, 10, 10], // mm
//     filename: `report-${Date.now()}.pdf`,
//     image: { type: "jpeg", quality: 0.98 },
//     html2canvas: {
//       scale: 2,
//       useCORS: true,
//       ignoreElements: (el) => el.classList.contains("no-export"),
//       onclone: (doc) => {
//         doc.body.classList.add("exporting");
//       },
//     },
//     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
//     pagebreak: {
//       mode: ["css", "legacy"],
//       before: ".page-break-before",
//       after: ".page-break-after",
//       avoid: [".page-break-avoid", ".page-keep"],
//     },
//   };
//   html2pdf().set(opt).from(el).save();

function onPickAddress(_item) {
  /* ถ้าต้องทำอย่างอื่นเพิ่ม ใส่ตรงนี้ */
}

// ---------------autoComplete---------------
function normalizeAutoComplete(res) {
  if (Array.isArray(res)) return res;
  const arr = res?.data?.data?.data ?? res?.data?.data ?? [];
  return Array.isArray(arr) ? arr : [];
}

const fetchAddress = async ({ query, offset }) => {
  await nextTick();
  const q = typeof query === "string" ? query : "";
  const res = await shelterStore.autoCompleteAddress({
    search: q,
    offset: offset ?? 0,
  });
  return normalizeAutoComplete(res);
};

const selectBirthDate = (date) => {
  form.birth_date = date;
};
</script>

<style lang="scss" scoped>
.title {
  color: var(--text-color-text-grey-darkest, #1f1d1f);
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  /* 150% */
  letter-spacing: 0.1px;
}

@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}

.fontSize14{
  font-size: 14px;
}
</style>
